import { getCookie } from '../util/util'

// 商城主体域名
export function maindomain() {
    let maindomain = JSON.parse(getCookie('allreqdomain'))
    if (maindomain.maindomain.pc) {
        let maindomains = maindomain.maindomain.pc.split(',')
        for (let i = 0; i < maindomains.length; i++) {
            if (maindomains[i].indexOf('cutmall.cn') > -1) {
                let home = maindomains[i]
                return home
            }
        }
    } else {
        return
    }
}
// 商城主体模板路径
export function templatemain() {
    let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
    let templatemain = v.templatemain
    return templatemain
}
// 预售板块域名
export function preselldomain() {
    // console.log('1232')
    let preselldomain = JSON.parse(getCookie('allreqdomain'))
    if (preselldomain.preselldomain.pc) {
        let preselldomains = preselldomain.preselldomain.pc.split(',')
        for (let i = 0; i < preselldomains.length; i++) {
            if (preselldomains[i].indexOf('cutmall.cn') > -1) {
                let sale = preselldomains[i]
                    // console.log(sale, '1232')
                return sale
            }
        }
    } else {
        return
    }
}
// 预售板块模板路径
export function templatepresall() {
    let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
    let templatepresall = v.templatepresall
    return templatepresall
}
// 溯源板块域名
export function tracedomain() {
    let tracedomain = JSON.parse(getCookie('allreqdomain'))
    if (tracedomain.tracedomain.pc) {
        let tracedomains = tracedomain.tracedomain.pc.split(',')
        for (let i = 0; i < tracedomains.length; i++) {
            if (tracedomains[i].indexOf('cutmall.cn') > -1) {
                let trace = tracedomains[i]
                return trace
            }
        }
    } else {
        return
    }
}
// 溯源板块模板路径
export function templatetrace() {
    let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
    let templatetrace = v.templatetrace
    return templatetrace
}

// 官网板块域名
export function websitedomain() {
    let websitedomain = JSON.parse(getCookie('allreqdomain'))
    if (websitedomain.websitedomain.pc) {
        let websitedomains = websitedomain.websitedomain.pc.split(',')
        for (let i = 0; i < websitedomains.length; i++) {
            if (websitedomains[i].indexOf('cutmall.cn') > -1) {
                let trace = websitedomains[i]
                return trace
            }
        }
    } else {
        return
    }
}
// 官网板块模板路径
export function templatewebsite() {
    let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
    let templatewebsite = v.templatewebsite
    return templatewebsite
}
  
// 积分商城域名pc
export  function templatedomain () {
   //线上正式
    let domain = 'https://points.cutmall.cn'
    //线上测试
    //let domain = 'http://jftest.maboy.cn'
    return domain
  }


// 移动商城主体域名
export function maindomainMobile() {
    let maindomain = JSON.parse(getCookie('allreqdomain'))
    if (maindomain.maindomain.mob) {
        let maindomains = maindomain.maindomain.mob.split(',')
        for (let i = 0; i < maindomains.length; i++) {
            if (maindomains[i].indexOf('th28.cn') > -1) {
                let home = maindomains[i]
                return home
            }
        }
    } else {
        return
    }
}
// 商城主体模板路径
export function templatemainMobile() {
    let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
    let mobtemplatemain = v.mobtemplatemain
    return mobtemplatemain
}
// 预售板块域名
export function preselldomainMobile() {
    // console.log('1232')
    let preselldomain = JSON.parse(getCookie('allreqdomain'))
    if (preselldomain.preselldomain.mob) {
        let preselldomains = preselldomain.preselldomain.mob.split(',')
        for (let i = 0; i < preselldomains.length; i++) {
            if (preselldomains[i].indexOf('th28.cn') > -1) {
                let sale = preselldomains[i]
                    // console.log(sale, '1232')
                return sale
            }
        }
    } else {
        return
    }

}
// 预售板块模板路径
export function templatepresallMobile() {
    let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
    let mobtemplatepresall = v.mobtemplatepresall
    return mobtemplatepresall
}
// 溯源板块域名
export function tracedomainMobile() {
    let tracedomain = JSON.parse(getCookie('allreqdomain'))
    if (tracedomain.tracedomain.mob) {
        let tracedomains = tracedomain.tracedomain.mob.split(',')
        for (let i = 0; i < tracedomains.length; i++) {
            if (tracedomains[i].indexOf('th28.cn') > -1) {
                let trace = tracedomains[i]
                return trace
            }
        }
    } else {
        return
    }
}
// 溯源板块模板路径
export function templatetraceMobile() {
    let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
    let mobtemplatetrace = v.mobtemplatetrace
    return mobtemplatetrace
}


// WEBPACK FOOTER //
// ./src/util/init.js